import React from 'react';

import { node } from 'prop-types';

import { StyledMain } from './styles';

const Main = ({ children }) => <StyledMain>{children}</StyledMain>;

Main.propTypes = {
  children: node,
};

Main.defaultProps = {
  children: null,
};

export default Main;
